export default __webpack_public_path__ + "static/media/Shape 2.a26f0d63.png";